import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';

import { ModelBase } from '../../model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';

@Injectable()
export class NowNiFiServiceApi {
    public static postNifiServiceData(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ApiResponse> {
        return http.post('/nifi-service/customer_event_data', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        });
    }
}

ModelBase.persistMapping[StoreAction.POST_NIFI_SERVICE] = NowNiFiServiceApi.postNifiServiceData;
